import { useMutation, useQueryClient } from 'react-query';
import { useParams, useNavigate } from 'react-router-dom';

// our axios
import axiosInstance from 'services/API/API';

// Our Endpoints
import { getUserLiabilitiesUrl as savePersonalLiabilityURL } from 'shared/api-urls';

// Our Routes
import { IDENTIFIED_LIABILITIES_ROUTE } from 'routes';

// Our query keys
import { USER_LIABILITIES, WALLET_OVERVIEW_DATA } from 'shared/query-keys';

function useMutateSavePersonalLiability() {
	const navigate = useNavigate();
	const { tradeLineId } = useParams();

	const queryClient = useQueryClient();

	const urlForRequest = `${savePersonalLiabilityURL}${tradeLineId}`;

	return useMutation(
		async (personalLiabilityData) => {
			// dynamic entries will be patch calls
			const response = await axiosInstance.patch(
				urlForRequest,
				personalLiabilityData
			);

			await queryClient.invalidateQueries(WALLET_OVERVIEW_DATA, {
				refetchInactive: true
			});

			await queryClient.invalidateQueries(USER_LIABILITIES, {
				refetchInactive: true
			});

			return response.data;
		},
		{
			onSuccess: () => {
				navigate(IDENTIFIED_LIABILITIES_ROUTE);
			}
		}
	);
}

export default useMutateSavePersonalLiability;
